import { Button, Colors } from '@honeyscience/honey-ui-toolkit';
import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { createUseStyles } from 'react-jss';

type CopyFieldProps = {
  id: string;
  title: string;
  value: string;
  isCopied?: boolean;
  handleCopyToClipboard?: any;
};

type StyleProps = { isCopied: CopyFieldProps['isCopied'] };

const useStyles = createUseStyles({
  buttonContainer: {
    width: '66px',
  },
  cardInfo: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },
  cardInfoValue: {
    backgroundColor: ({ isCopied }: StyleProps) => (isCopied ? Colors.grey300 : Colors.grey150),
    border: 'none',
    borderRadius: '4px',
    color: Colors.grey900,
    marginRight: '16px',
    overflow: 'hidden',
    padding: '4px 8px',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    transition: 'all 0.2s ease 0s',
    width: '206px',
  },
  field: {
    '&:not(:first-child)': {
      marginTop: '10px',
    },
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    height: '52px',
  },
  title: {
    color: Colors.grey700,
    fontSize: '9px',
    fontWeight: '500',
    letterSpacing: '0.1em',
    lineHeight: '16px',
    marginBottom: '4px',
  },
});

function CopyField({
  id,
  title,
  value,
  isCopied,
  handleCopyToClipboard,
}: CopyFieldProps): ReactElement {
  const classes = useStyles({ isCopied });

  return (
    <div className={ classes.field }>
      <div className={ classes.title }>
        { title }
      </div>
      <div className={ classes.cardInfo }>
        <div
          className={ classNames('mono4', classes.cardInfoValue) }
        >
          { value }
        </div>
        <div className={ classes.buttonContainer }>
          <Button
            buttonType={ isCopied ? 'secondary' : 'third' }
            copy={ isCopied ? 'Copied!' : 'Copy' }
            id={ id }
            isFlexible
            onClick={ handleCopyToClipboard(value, id) }
            size={ 24 }
          />
        </div>
      </div>
    </div>
  );
}

CopyField.defaultProps = {
  handleCopyToClipboard: () => {},
  isCopied: false,
};

export default CopyField;
